import React from "react";
import { getUrlToListPackagesPage } from "../urls";
import { Link, useLocation, Navigate, useNavigate } from "react-router-dom";
import { TabView, TabPanel } from "primereact/tabview";
import sort from "../../images/sort.svg";
import earn from "../../images/earn.jpg";
import send from "../../images/send.svg";
import demand from "../../images/demand.jpg";
import quality from "../../images/quality.jpg";
import retail from "../../images/retail.jpg";
import { useIsAuthenticated } from "utils/auth";
import { HomeInfoModal } from "components/HomeInfoModal";
import { Footer } from "shared/components/Footer";
import "./index.css";

const VIEW_PACKAGES_URL = getUrlToListPackagesPage();

const TAB_NAME_TO_INDEX = [
  "how-it-works",
  "commission-and-fees"
]

export function HomePage() {
  const { hash } = useLocation();
  const navigate = useNavigate();

  const activeTab = (() => {
    const activeTabName = hash.split("#")[1];
    const idx = TAB_NAME_TO_INDEX.findIndex(name => name === activeTabName);
    return idx === -1 ? 0 : idx;
  })();

  const setActiveTab = (tabIndex: number) => {
    navigate({ hash: TAB_NAME_TO_INDEX[tabIndex] })
  }

  const isAuthenticated = useIsAuthenticated();

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();

    const form = e.currentTarget;

    const search = form.querySelector("input")?.value;

    if (search) {
      window.location.href = `https://shop.antidotenepal.com/shop?searchQuery=${search}`;
    }
  };

  if (isAuthenticated) {
    return (
      <Navigate to={getUrlToListPackagesPage()} />
    )
  }

  return (
    <>
      <div className="mx-2 align-items-center hidden md:flex">
        <a
          href="https://shop.antidotenepal.com"
          style={{ textDecoration: "none", color: "black" }}
        >
          <h2 className="my-0 p-3 font-normal">SHOP</h2>
        </a>
        <h2 className="my-0 p-3" style={{ background: "#D9D9D9" }}>
          SELL
        </h2>
        <form id="search" onSubmit={handleSearch}>
          <input
            name="search"
            className="mx-3 p-2 border-round-3xl border-1"
            style={{ width: "200px" }}
            type="text"
            placeholder="Search for anything"
          />
        </form>
      </div>
      <TabView className="home-tab hidden md:block" activeIndex={activeTab} onTabChange={(e) => setActiveTab(e.index)}>
        <TabPanel className="home-tab-panel" header="How it works?">
          <div
            style={{ background: "#9731E8", maxWidth: "1367px" }}
            className="m-2 p-3 border-round mx-auto"
          >
            <h1 className="text-2xl font-bold text-white mb-4">
              Join 5000+ sellers who choose Antidote to de-clutter their closets
              and home.
            </h1>
            <Link
              className="block w-fit border-1 border-white text-white py-2 px-3 no-underline cursor-pointer"
              to={VIEW_PACKAGES_URL}
            >
              GET STARTED
            </Link>
          </div>
          <div className="text-center my-4">
            <h2 className="uppercase">How it works?</h2>
            <p className="font-normal mx-auto" style={{ maxWidth: "700px" }}>
              Selling at Antidote is easy and convenient. Simply sort the items
              you would like to sell, send them to us and earn a decent passive
              income.
            </p>
          </div>
          <div
            className="tab-panel-items m-0 flex mx-auto"
            style={{ maxWidth: "1367px" }}
          >
            <HomeInfoItem
              image={sort}
              title="Sort"
              description="Sort the items that you want to sell. We accept women's, men's, and kids' apparel, accessories, books, bags and shoes."
            />
            <HomeInfoItem
              image={send}
              title="Send"
              description="Send them to Antidote and earn a decent passive income."
            />
            <HomeInfoItem
              image={earn}
              title="Earn"
              description="We credit your bank account twice a month (GIVEN YOUR ITEMS ARE SOLD)."
            />
          </div>
        </TabPanel>
        <TabPanel className="home-tab-header" header="Commission and Fees">
          <div
            style={{ background: "#9731E8", maxWidth: "1367px" }}
            className="m-2 p-3 border-round mx-auto"
          >
            <h1 className="text-2xl font-bold text-white mb-4">
              Join 5000+ sellers who choose Antidote to de-clutter their closets
              and home.
            </h1>
            <Link
              className="block w-fit border-1 border-white text-white py-2 px-3 no-underline cursor-pointer"
              to={VIEW_PACKAGES_URL}
            >
              GET STARTED
            </Link>
          </div>
          <div
            className="text-center my-4 mx-auto"
            style={{ maxWidth: "1367px" }}
          >
            <h2 className="uppercase">HOW IS PRICING DONE?</h2>
            <p className="font-normal mx-auto" style={{ maxWidth: "700px" }}>
              Pricing is determined by current demand, quality, and estimated
              retail price. Not happy with the prices? You can always revise and
              review the prices from the seller portal.
            </p>
          </div>
          <div
            className="tab-panel-items m-0 flex mx-auto"
            style={{ maxWidth: "1367px" }}
          >
            <HomeInfoItem
              image={demand}
              title="Current Demand"
              description="Current demand is affected by what’s in trend and the season"
            />
            <HomeInfoItem
              image={quality}
              title="Quality"
              description="We only accept items that are free from lint/piling, fading, shrinkage, stains, missing parts, broken zippers."
            />
            <HomeInfoItem
              image={retail}
              title="Estimated Retail"
              description="Our expert team factors in the current retail prices while setting the prices."
            />
          </div>
        </TabPanel>
      </TabView>
      <div style={{ maxWidth: "1367px", margin: "0 auto" }}>
        <div
          style={{ background: "#9731E8" }}
          className="m-2 p-3 border-round md:hidden"
        >
          <h1 className="text-2xl font-bold text-white mb-4">
            Join 5000+ sellers who choose Antidote to de-clutter their closets
            and home.
          </h1>
          <Link
            className="block w-fit border-1 border-white text-white py-2 px-3 no-underline cursor-pointer"
            to={VIEW_PACKAGES_URL}
          >
            GET STARTED
          </Link>
        </div>
        <div className="md:hidden home-accordion mx-2 my-4 border-round">
          <HomeInfoModal
            title="How it works?"
            description="Simply sort the items you would like to sell, send them to us and earn a decent passive income."
          >
            <HomeInfoItem
              image={sort}
              title="Sort"
              description="Sort the items that you want to sell. We accept women's, men's, and kids' apparel, accessories, books, bags and shoes."
            />
            <HomeInfoItem
              image={send}
              title="Send"
              description="Send them to Antidote and earn a decent passive income."
            />
            <HomeInfoItem
              image={earn}
              title="Earn"
              description="We credit your bank account twice a month (GIVEN YOUR ITEMS ARE SOLD)."
            />
          </HomeInfoModal>
          <HomeInfoModal
            title="Commission and Fees"
            description="Learn about how the pricing is done and the commission and fees."
          >
            <HomeInfoItem
              image={demand}
              title="Current Demand"
              description="Current demand is affected by what’s in trend and the season"
            />
            <HomeInfoItem
              image={quality}
              title="Quality"
              description="We only accept items that are free from lint/piling, fading, shrinkage, stains, missing parts, broken zippers."
            />
            <HomeInfoItem
              image={retail}
              title="Estimated Retail"
              description="Our expert team factors in the current retail prices while setting the prices."
            />
          </HomeInfoModal>
        </div>
        <div
          className="mx-2 my-4 py-4 border-round"
          style={{ background: "rgba(207, 175, 233, 0.77)" }}
        >
          <h1 className="text-2xl font-semibold px-3 ">WHY ANTIDOTE?</h1>
          <h1 className="text-xl font-normal px-3 ">Track your items</h1>
          <p className="px-3 my-4">
            Antidote is the only thrift service in Nepal that lets you track
            your inventory in real time.
            <br />
            <br />
            You can check status of all of your items using the seller portal.
            Track your income, sold/unsold inventory, revisit the prices and
            many more, all in a single easy to use platform.
          </p>
          <div className="divider"></div>
          <h1 className="text-xl font-normal px-3">Review Prices</h1>
          <p className="px-3 my-4">
            Not happy with our prices? No problem. You can review and revise the
            prices from the seller portal.
            <br />
            <br />
            Want to lower the prices? No problem. You can reduce the price and
            attract new buyers.
          </p>
          <div className="divider"></div>
          <h1 className="text-xl font-normal px-3 ">Selection Criteria</h1>
          <p className="px-3 my-4">
            We provide our sellers with recommended selling prices that factor in the quality of the items,
            the current trend, seasonal relevance, and what similar items on our platform are selling for.
            Only 60% of the items are selected on average.
          </p>
        </div>
        <div className="mx-2 my-4 py-4">
          <h2 className="text-center mb-6">
            TRUSTED BY <br />
            <span style={{ color: "#9731E8" }}>5,000+</span> SELLERS
          </h2>
          <div
            style={{ background: "#9731E8" }}
            className="my-2 p-3 border-round "
          >
            <h1 className="text-2xl font-bold text-white mb-4">
              De-clutter your home today!
            </h1>
            <p className="text-white my-4">
              Sell your pre-loved and like-new apparel, accessories, books,
              bags, shoes and more from the comfort of your home.
            </p>
            <Link
              className="block w-fit border-1 border-white text-white py-2 px-3 no-underline cursor-pointer"
              to={VIEW_PACKAGES_URL}
            >
              GET STARTED
            </Link>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
}

const HomeInfoItem = ({ image, title, description }) => {
  return (
    <div className="home-info-item flex flex-column align-items-center justify-content-center my-4">
      <img src={image} alt={title} width="230" height="230" style={{ maxWidth: "230px" }} />
      <h4 className="mb-1">{title}</h4>
      <p className="text-center">{description}</p>
    </div>
  );
};
